import { Link } from "react-router-dom";
import { ArrowUpRight, Home, Users, Building2, Plane, TrendingUp, Trees, GraduationCap } from "lucide-react";
import { Reveal } from "@/components/Motion";
import { IMAGES } from "@/data";

const SEGMENTS = [
  { icon: Users, t: "First-time buyers", d: "Step-by-step guidance from preapproval to closing." },
  { icon: Home, t: "Move-up buyers", d: "Coordinate buying and selling with confidence." },
  { icon: Building2, t: "New construction", d: "Navigate builder contracts and incentives." },
  { icon: Plane, t: "Relocation buyers", d: "Get oriented to Metro Atlanta communities." },
  { icon: TrendingUp, t: "Investment properties", d: "Evaluate rental and long-term hold options." },
  { icon: Trees, t: "Homes with acreage", d: "Find more land in growing outer counties." },
  { icon: GraduationCap, t: "Buyer education", d: "Free guides, calculators, and checklists." },
];

export default function Buy() {
  return (
    <div className="bg-cream pt-24">
      <section className="px-6 md:px-12 py-16 md:py-24">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <Reveal><p className="font-mono text-xs uppercase tracking-[0.3em] text-green mb-4">For Buyers</p></Reveal>
            <Reveal delay={0.1}><h1 className="font-serif text-5xl md:text-6xl text-navy tracking-tighter leading-[0.95] mb-6">Find a home that fits your life and your budget.</h1></Reveal>
            <Reveal delay={0.2}><p className="text-lg text-charcoal/75 mb-8 max-w-lg">Take a short, no-pressure questionnaire and receive personalized guidance, recommended areas, and clear next steps.</p></Reveal>
            <Reveal delay={0.3} className="flex flex-wrap gap-4">
              <Link to="/buy/questionnaire" data-testid="buy-start-quiz" className="bg-gold text-navy font-semibold px-8 py-4 rounded-full hover:scale-105 transition-transform inline-flex items-center gap-2">
                Start the Buyer Questionnaire <ArrowUpRight size={18} />
              </Link>
              <Link to="/search" data-testid="buy-browse" className="border border-navy/20 text-navy font-semibold px-8 py-4 rounded-full hover:bg-navy hover:text-cream transition-colors">Browse Homes</Link>
            </Reveal>
          </div>
          <Reveal delay={0.2}><img src={IMAGES.interior1} alt="Home interior" className="rounded-[2rem] shadow-2xl w-full h-[420px] object-cover" /></Reveal>
        </div>
      </section>

      <section className="px-6 md:px-12 py-20 bg-white">
        <div className="max-w-7xl mx-auto">
          <Reveal><h2 className="font-serif text-4xl md:text-5xl text-navy tracking-tight mb-12">Guidance for every kind of buyer</h2></Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {SEGMENTS.map((s, i) => (
              <Reveal key={s.t} delay={i * 0.05}>
                <div className="bg-cream rounded-2xl p-8 border border-black/5 h-full">
                  <s.icon className="text-gold mb-5" size={28} />
                  <h3 className="font-serif text-xl text-navy mb-2">{s.t}</h3>
                  <p className="text-charcoal/70 text-sm">{s.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2} className="mt-12">
            <Link to="/buy/questionnaire" data-testid="buy-cta-bottom" className="bg-navy text-cream font-semibold px-8 py-4 rounded-full inline-flex items-center gap-2 hover:bg-navy/90 transition-colors">
              Get My Personalized Plan <ArrowUpRight size={18} />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
